import apiClient from '../utils/apiClient';

const facilitiesService = {
  getAll: () => apiClient.get('/api/facilities/'),
  getById: (id) => apiClient.get(`/api/facilities/${id}`),
  create: (data) => apiClient.post('/api/facilities/', data),
  update: (id, data) => apiClient.put(`/api/facilities/${id}`, data),
  delete: (id) => apiClient.delete(`/api/facilities/${id}`),
  deletePreview: (id) => apiClient.get(`/api/facilities/${id}/delete-preview`),
};

export default facilitiesService;
